const Clock = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M32 0a32 32 0 1 0 32 32A32 32 0 0 0 32 0zm13.663 41.253a1.5 1.5 0 0 1-2.05.544L30 33.9V9.5a1.5 1.5 0 0 1 3 0v22.669L45.119 39.2a1.5 1.5 0 0 1 .544 2.053z"
      fill={color}
    ></path>
  </svg>
);

export default Clock;
